/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeChartOverview } from "../../d-chart-overview";
import { DThemeDarkBase } from "./d-theme-dark-base";

export class DThemeDarkChartOverview extends DThemeDarkBase implements DThemeChartOverview {}
